import { Quote, MessageCircle } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { scrollToSection } from "@/lib/scroll";

export const Testimonials = () => (
  <section id="testimoni" className="bg-white" aria-label="Testimoni">
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-12 lg:py-28">
      <Reveal className="mx-auto max-w-2xl text-center">
        <Eyebrow>Testimoni</Eyebrow>
        <h2 className="text-balance font-heading text-3xl font-extrabold leading-tight tracking-tight text-navy sm:text-4xl">
          Kata Mereka tentang <span className="italic text-orange-500">Karya Kami</span>
        </h2>
      </Reveal>

      <Reveal delay={0.12} className="mx-auto mt-12 max-w-3xl">
        <div
          data-testid="testimonial-empty-state"
          className="flex flex-col items-center rounded-3xl border-2 border-dashed border-slate-300 bg-mist px-6 py-14 text-center sm:px-12"
        >
          <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-navy">
            <Quote className="h-7 w-7 text-orange-400" aria-hidden="true" />
          </span>
          <h3 className="mt-6 font-heading text-xl font-bold text-navy">
            Kami Siap Membuktikan Kualitas Karya Kami pada Proyek Anda
          </h3>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-600">
            Bagian ini hanya akan menampilkan testimoni asli dari klien kami.
            Jadilah proyek pertama yang kami banggakan di halaman ini.
          </p>
          <a
            href="#kontak"
            data-testid="testimonial-cta-invite"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("#kontak");
            }}
            className="mt-7 inline-flex items-center gap-2.5 rounded-full bg-orange-500 px-7 py-3 text-sm font-bold text-white transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-orange-600"
          >
            <MessageCircle className="h-4 w-4" aria-hidden="true" />
            Hubungi Tim Kami
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
